
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession } from '@supabase/auth-helpers-react';
import { getUserStats, getUserGameHistory, getUserSOSEvents } from '@/services/progressService';
import ProfileHeader from '@/components/profile/ProfileHeader';
import ProfileTabs from '@/components/profile/ProfileTabs';

const Profile = () => {
  const navigate = useNavigate();
  const session = useSession();
  const [stats, setStats] = useState<any>(null);
  const [gameHistory, setGameHistory] = useState<any[]>([]);
  const [sosEvents, setSOSEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!session) {
      navigate('/');
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const stats = await getUserStats();
        const gameHistory = await getUserGameHistory();
        const sosEvents = await getUserSOSEvents();
        
        setStats(stats);
        setGameHistory(gameHistory);
        setSOSEvents(sosEvents);
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [session, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-cream-light flex items-center justify-center">
        <div className="text-center">
          <p className="text-lg">Loading your progress...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream-light flex flex-col">
      <ProfileHeader totalSOSEvents={stats?.totalSOSEvents || 0} />
      
      <div className="flex-grow container mx-auto max-w-4xl p-4">
        <ProfileTabs 
          stats={stats}
          gameHistory={gameHistory}
          sosEvents={sosEvents}
        />
      </div>
    </div>
  );
};

export default Profile;
